/** Shared shape for the combined company + owner form (Add Client and Edit client). */

export const COMPANY_OWNER_FIELDS = [
    "firstName", "lastName", "email", "phoneNumber", "additionalInfo",
    "companyName", "companyNip", "companyWebsite",
    "billingStreet", "billingBuildingNumber", "billingPostalCode", "billingCity", "billingCountry",
];

export const emptyCompanyOwnerForm = () =>
    COMPANY_OWNER_FIELDS.reduce((acc, key) => ({ ...acc, [key]: "" }), {});

export const companyOwnerFormFrom = (owner) =>
    COMPANY_OWNER_FIELDS.reduce((acc, key) => ({ ...acc, [key]: owner?.[key] ?? "" }), {});

/** Only first name, last name and email are required. Returns an error string or null. */
export const validateCompanyOwnerForm = (form) => {
    if (!form.firstName.trim() || !form.lastName.trim() || !form.email.trim()) {
        return "First name, last name and email are required";
    }
    return null;
};
